enum Breakpoints {
  SS_320 = 320,
  XS_420 = 420,
  SM_600 = 600,
  SX_720 = 720,
  MD_960 = 960,
  LG_1280 = 1280,
  XL_1920 = 1920
}

export default Breakpoints;
